import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaUILayersUtility from '@sparta.global.utilities/sparta-ui-layers-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.credit-cards.modules/page-level-cc-mya-module",
  "version": "1.0.2",
  "id": "pageLevelCcMyaModule",
  "containerID": "creditCardsPageLevelCcMyaModule",
  "moduleName": "credit-cards-page-level-cc-mya-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "page-level-cc-mya-module",
  "data": {
    "init": "pageLevelCcMyaModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-ui-layers-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/* global spaParams */

/*
 * page-level-cc-mya-module
 * module_js_id: pageLevelCcMyaModuleJS
 *
 * Copyright (c) 2017-12-4 removed
 */
/**
 * @export
 * @class pageLevelCcMyaModuleJS
 * @extends {Module}
 */

class pageLevelCcMyaModuleJS extends Module {
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * @todo Change the template in sign-in-cc-mya-module with the link helper in the JCR to trigger
   * the modal instead. This fix is for a release issue and I don't want to make too many updates
   * right now.
   */
  init() {
    $('#sign-in-modal').on('click', e => {
      const value = $(e.target).data('href');
      spartaUILayersUtility.openLayer($(value));
    });
  }
}
registerModuleClass({
  moduleClass: pageLevelCcMyaModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { pageLevelCcMyaModuleJS as default, moduleConfig };
